import { ADDITIONAL_PARTICIPANT_EVENTS } from '../../../event_bus_modules/additional_participant';
import { ADDITIONAL_DETAILS_EVENTS } from '../../../event_bus_modules/additional_details';

$(() => {
  const whoIsProvidingFunds = $('.who-is-providing-the-funds');
  const isRequired =
    whoIsProvidingFunds.find('input[name="is-mandatory"]').val() === 'True';
  const addedPersonsSection = whoIsProvidingFunds.find(
    '.additional-participant__added-persons'
  );
  const initializeWhoIsProvidingFundsSection = (htmlElement) => {
    const element = $(htmlElement);

    // sections containers
    const whoIsProvidingPaymentDetailsContainer = $(
      '#who-is-providing-payment-details-container'
    );
    const fundsProviderFormContainer = $('#funds-provider-form-container');

    // who is providing the funds section
    const providingFundsMyselfButton = element.find(
      '#who-is-providing-the-funds-myself'
    );
    const providingFundsSomeoneElseButton = element.find(
      '#who-is-providing-the-funds-someone-else'
    );
    const whoIsProvidingFundsInput = element.find(
      "input[name='who-is-providing-the-funds']"
    );

    // who is providing payment details section
    const providingPaymentsDetailsMyselfButton = element.find(
      '#who-is-providing-payment-details-myself'
    );
    const providingPaymentsDetailsFundsProviderButton = element.find(
      '#who-is-providing-payment-details-funds-provider'
    );
    const whoIsProvidingPaymentDetailsInput = element.find(
      "input[name='who-is-providing-payment-details']"
    );

    const hasAddedPersons = () => {
      return addedPersonsSection.children().length;
    };

    const updateSectionValidationState = () => {
      if (isRequired) {
        const whoIsProvidingFundsInputValue = whoIsProvidingFundsInput.val();
        const whoIsProvidingPaymentDetailsValue = whoIsProvidingPaymentDetailsInput.val();
        let valid = true;
        if (whoIsProvidingFundsInputValue === 'someone-else') {
          if (whoIsProvidingPaymentDetailsValue === 'person') {
            valid = true;
          } else if (whoIsProvidingPaymentDetailsValue === 'funds-provider') {
            valid = hasAddedPersons();
          } else {
            valid = false;
          }
        } else if (whoIsProvidingFundsInputValue === 'myself') {
          valid = true;
        } else {
          valid = false;
        }
        const eventType = valid
          ? ADDITIONAL_DETAILS_EVENTS.REMOVE_ERROR
          : ADDITIONAL_DETAILS_EVENTS.ADD_ERROR;

        EVENT_BUS.dispatch(eventType, {
          error: ADDITIONAL_DETAILS_EVENTS.ERROR.FUNDS_PROVIDING,
        });
      }
    };

    const createSwitchableSection = ({
      containerToBeSwitched,
      buttonSwitchOn,
      buttonSwitchOff,
      sectionInput,
      inputToBeSwitchedAsSideEffect,
      resetButtons = true,
      callbackOnSwitch = () => {},
    }) => {
      const switchOnValue = buttonSwitchOn.get(0).dataset.value;
      const switchOffValue = buttonSwitchOff.get(0).dataset.value;
      let previousValue = sectionInput.val();

      const onButtonSwitchOn = () => {
        buttonSwitchOn.addClass('active');
        buttonSwitchOff.removeClass('active');
        sectionInput.val(switchOnValue).trigger('change');
      };

      const onButtonSwitchOff = () => {
        buttonSwitchOn.removeClass('active');
        buttonSwitchOff.addClass('active');
        sectionInput.val(switchOffValue).trigger('change');
      };

      if (sectionInput.val() == switchOnValue) {
        onButtonSwitchOn();
        containerToBeSwitched.switchClass('d-none', 'd-flex');
      } else if (sectionInput.val() == switchOffValue) {
        onButtonSwitchOff();
      }

      const onSectionInputChange = ($event) => {
        const { value } = $event.target;
        if (value === switchOnValue) {
          containerToBeSwitched.switchClass('d-none', 'd-flex');
        } else {
          if (value === '' && resetButtons) {
            buttonSwitchOn.removeClass('active');
            buttonSwitchOff.removeClass('active');
          }
          containerToBeSwitched.switchClass('d-flex', 'd-none');
          inputToBeSwitchedAsSideEffect?.val('').trigger('change');
        }
        updateSectionValidationState();
        callbackOnSwitch({ previousValue, currentValue: value });
        previousValue = value;
      };

      buttonSwitchOn.on('click', onButtonSwitchOn);
      buttonSwitchOff.on('click', onButtonSwitchOff);
      sectionInput.on('change', onSectionInputChange);
    };

    createSwitchableSection({
      containerToBeSwitched: whoIsProvidingPaymentDetailsContainer,
      buttonSwitchOn: providingFundsSomeoneElseButton,
      buttonSwitchOff: providingFundsMyselfButton,
      sectionInput: whoIsProvidingFundsInput,
      inputToBeSwitchedAsSideEffect: whoIsProvidingPaymentDetailsInput,
      resetButtons: false,
    });

    createSwitchableSection({
      containerToBeSwitched: fundsProviderFormContainer,
      buttonSwitchOn: providingPaymentsDetailsFundsProviderButton,
      buttonSwitchOff: providingPaymentsDetailsMyselfButton,
      sectionInput: whoIsProvidingPaymentDetailsInput,
      inputToBeSwitchedAsSideEffect: null,
      resetButtons: true,
      callbackOnSwitch: ({ previousValue, currentValue }) => {
        if (
          previousValue === 'funds-provider' &&
          previousValue !== currentValue
        ) {
          EVENT_BUS.dispatch(
            ADDITIONAL_PARTICIPANT_EVENTS.RESET_PARTICIPANT_FORM,
            { type: 'FUNDS_PROVIDER' }
          );
        }
      },
    });

    EVENT_BUS.on(ADDITIONAL_PARTICIPANT_EVENTS.REMOVED_PARTICIPANT, () => {
      updateSectionValidationState();
    });
    EVENT_BUS.on(
      ADDITIONAL_PARTICIPANT_EVENTS.ADDED_SELECTED_PARTICIPANT,
      () => {
        updateSectionValidationState();
      }
    );
    EVENT_BUS.on(ADDITIONAL_PARTICIPANT_EVENTS.ADDED_NEW_PARTICIPANT, () => {
      updateSectionValidationState();
    });
    updateSectionValidationState();
  };

  whoIsProvidingFunds.each((_, element) =>
    initializeWhoIsProvidingFundsSection(element)
  );
});
